var render = function render(){var _vm=this,_c=_vm._self._c;return _c('QuoteLoading',{attrs:{"loading":_vm.loadingQuote || _vm.loadingUser || _vm.applicationLoading || !_vm.redirectionHandled,"quote-id":_vm.quoteId}})
}
var staticRenderFns = []

export { render, staticRenderFns }